import React, {useState, useEffect} from 'react'
import firebase from '../../firebase/config'
import {Link, useHistory, useLocation} from 'react-router-dom';
import moment from 'moment';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import axios from 'axios';

function Interested() {

  const history = useHistory()
  let data = useLocation();
  const [pet, setPet] = useState({})
  const [user, setUser] = useState({})
  const [alert, setAlert] = useState(false)
  const [alertMessage, setAlertMessage] = useState("")
  const [successMsg, setSuccessMsg] = useState("");
  const [success, setSuccess] = useState(false);

  
  const [interesados, setInteresados] = useState([])
  
  function uniqBy(a, key) {
    var seen = {};
    return a.filter(function(item) {
      var k = key(item);
        return seen.hasOwnProperty(k) ? false : (seen[k] = true);
      })
  }
  
  async function getPetInterested(mid){
    let array = []
    await firebase.db.collection("Mascotas").doc(mid).collection("Interesados").get().then((val)=>{
      val.docs.forEach((e)=>{
        firebase.db.collection("Dueños").doc(e.id).get().then((a)=>{
          array.push(a.data())
          setInteresados([...interesados, a.data()])
        })
      });
      // setInteresados(array)
    })
    // let a = uniqBy(array, JSON.stringify)
    // setInteresados(a)
    
  }

  const deletePerson = (o) => {
    setInteresados(interesados.filter((o1) => o1 !== o))
    setAlert(true)
  }

  const AlertComponent = ({msg}) => {
    return (
      <div className="info-alert color-secondary">
        <span className="material-icons mr-2">perm_identity</span>
        {msg}
        <div onClick={()=>{setAlert(false)}} className="material-icons ml-2 cursor-pointer">close</div>
      </div>
    )
  }

  const SuccessComponent = ({msg}) => {
    return (
      <div className="success-alert">
            <span className="material-icons mr-2">done</span>
            {msg}
            <div onClick={()=>{setSuccess(false)}} className="material-icons ml-2 cursor-pointer">close</div>
        </div>
    )
  }

  let pet2 = data.state.pet
  
    useEffect(() => {
      firebase.getCurrentUser().then((val)=>{
        setUser(val)
        setPet(data.state.pet)
        getPetInterested(data.state.pet.mid)
      });
    }, [])
    
    return (
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <div className="main-content-container container-fluid px-4">
            {alert && <AlertComponent msg={alertMessage === "" ? "Se le informara a este usuario que no cumple con los requisitos" :  alertMessage}/>}
            {success && <SuccessComponent msg={successMsg === "" ? "Mascota cargada exitosamente" : successMsg}/>}

            <div className="page-header align-items-center justify-content-spacebetween row no-gutters px-4 my-4">
              <div className="col-lg-10 col-sm-5 text-center text-sm-left mb-0">
                <div className="row align-items-center">
                    <p className="page-title bold"><Link className="page-title light px-3" to="/adoption">Adoptar o Apadrinar</Link><span>Interesados</span></p>
                </div>
              </div>
              <div className="col-lg-1 col-sm-1 mb-0">
                <div className="row align-items-center justify-content-space-around">
                  <i className="material-icons color-white display-5">help_outline</i>
                </div>
              </div>
            </div>

            <div className="container-fluid">
              <div className="color-primary mb-3">Aquí puedes decidir quien es el más indicado para adoptar a {pet.nombre}</div>
              <div className="row no-gutters align-items-center">
                {
                  interesados.length > 0 ? interesados.map((o, i)=>{
                    return(
                      <div key={i} className="interested-card col-lg-3 mr-3 mb-2">
                        <div className="interested-card-header">
                          <div className="interested-card-header-img">
                            <img src={o.url}/>
                          </div>
                        </div>
                        <div className="interested-card-body">
                          <div className="interested-card-body-p-wrapper">
                            <p className="interested-card-body-p-title color-secondary mb-0">Nombre completo</p>
                            <p className="color-primary mb-0">{o.nombre} {o.apellido}</p>
                          </div>
                          <div className="interested-card-body-p-wrapper">
                            <p className="interested-card-body-p-title color-secondary mb-0">email</p>
                            <p className="color-primary mb-0">{o.email}</p>
                          </div>
                          <div className="interested-card-body-p-wrapper">
                            <p className="interested-card-body-p-title color-secondary mb-0">Teléfono</p>
                            <p className="color-primary mb-0">{o.telefono}</p>
                          </div>
                        </div>
                        <div className="interested-card-footer">
                          {pet2.newOwner === o.uid ?
                          <p className="color-success mb-0">
                            Pendiente por confirmación
                          </p>                          
                          :
                          <>
                            <button onClick={()=>{ deletePerson(o) }} className="interested-card-btn btn-outline-danger">
                              <span className="material-icons">close</span>Rechazar
                            </button>
                            <button onClick={()=>{ approveUser(o) }} className="interested-card-btn btn-outline-success">
                              <span className="material-icons">done</span>Aprobar
                            </button>
                          </>
                          }
                        </div>
                      </div>
                    )
                  }) : <div className="col-lg-12">
                    Esta mascota no tiene interesados aún
                  </div>
                }
              </div>
            </div>
            
          </div>
        </MuiPickersUtilsProvider>
    )

  async function approveUser(user){

    //  var config = {
    //   headers: {
    //     'Content-type': 'application/json; charset=utf-8',
    //     'Access-Control-Allow-Origin':'*',
    //     'Access-Control-Allow-Methods': 'POST',
    //     'Access-Control-Allow-Headers':'Content-Type',
    //     // 'Access-Control-Allow-Credentials': true,
    //     'cache-control': 'no-cache'
    //   }
    // };

    // var token = user.token;
    // var token = "dUt0y7H0TpGBnk3hffW5G8:APA91bELRiesj-KpdpSF8ZkH5zj27wU-fe6jkJmlDDq0FxtIr21qzW3yxRBWkHBP9ZF8U-H9Kp7RpSLQyhNWiWPC1U-K4YtVb4XuqUIxCSAdurAQpG3jh94waorae0V-zf9qNkMcvAa2";

    // const notificationData = { registrationToken: token, message: "Prueba de envio desde la web" };
    // axios.post('https://us-central1-priority-pet.cloudfunctions.net/widgets/sendNotification', notificationData, config)
    // .then(response => alert(response));

    try{
      let mid = data.state.pet.mid
      await firebase.db.collection("Mascotas").doc(mid).update({
        newPet: true,
        newOwner: user.uid
      }).then((v)=>{
        setSuccessMsg("Al nuevo dueño se le notificará que fue aprobado")
        setSuccess(true)
        setTimeout(() => {
          setSuccess(false)
        }, 4000);
      })
      

    }catch(e){
      console.log("Error: " + e)
    }
  }

}

export default Interested